import { researchPlatform } from '@stereoagency/sanity-schema';
import {
  departmentProfilesQuery,
  relatedArticlesQuery,
  relatedJobsQuery,
  relatedProjectsQuery,
  platformLeaderQuery,
  taxonomiesQuery
} from '../groupOrPlatformSubqueries';

const groupPickFields = [
  '_id' as const,
  'slug' as const,
  'title' as const,
  'introduction' as const,
  'aboutContent' as const,
  'researchContent' as const,
  'bioContent' as const,
  'teamContent' as const,
  'departments' as const
];

const filter =
  'select(defined($slug) => slug.current == $slug, defined($id) => _id == $id, false)';
export const researchPlatformPageQuery = researchPlatform.schema.builder
  .filter(filter)
  .pick(groupPickFields)
  .subquery({
    taxonomies: taxonomiesQuery
  })
  .first()
  .use();

export const researchPlatformProjectsQuery = researchPlatform.schema.builder
  .filter(filter)
  .pick(['_id'])
  .subquery({
    projects: relatedProjectsQuery
  })
  .first()
  .use();

export const researchPlatformArticlesQuery = researchPlatform.schema.builder
  .filter(filter)
  .pick(['_id'])
  .subquery({
    articles: relatedArticlesQuery
  })
  .first()
  .use();

export const researchPlatformJobsQuery = researchPlatform.schema.builder
  .filter(filter)
  .pick(['_id'])
  .subquery({
    jobs: relatedJobsQuery
  })
  .first()
  .use();

export const researchPlatformProfilesQuery = researchPlatform.schema.builder
  .filter(filter)
  .pick(['_id'])
  .subquery({
    departmentProfiles: departmentProfilesQuery,
    researchPlatformLeader: platformLeaderQuery
  })
  .first()
  .use();
